import type { QueryStatus } from "@tanstack/react-query";

export type Snapshot = { value: unknown; status: QueryStatus; error: unknown };
export type Subscription = {
  snapshot: Snapshot;
  listeners: Set<() => void>;
  stop?: () => void;
  keepAlive?: boolean;
};
export const pending: Snapshot = {
  value: undefined,
  status: "pending",
  error: null,
};
export const subscriptions = new Map<string, Subscription>();

/** Called at account boundaries, before new private data is rendered. */
export function clearDocumentSubscriptions() {
  for (const subscription of subscriptions.values()) {
    subscription.stop?.();
    subscription.stop = undefined;
    subscription.snapshot = pending;
    subscription.listeners.forEach((notify) => notify());
  }
  subscriptions.clear();
}
